import { stenaStatisticsBar } from "@stenajs-webui/elements";
import * as React from "react";
import { useFilterWorkspace } from "../../hooks/UseFilterWorkspace";
import { RangeFilter } from "../../types/RangeFilter";
import { FppSearchFilterSection } from "../FppSearchFilterSection";
import { RangeControl } from "../RangeControl";

interface Props {
  enabled?: boolean;
  label?: string;
  labelFrom?: string;
  labelTo?: string;
  maxDecimals?: number;
  maxNumbers?: number;
}

export const StatNetworkVolumeFilterSection: React.FC<Props> = ({
  enabled,
  label,
  labelFrom,
  labelTo,
  maxDecimals,
  maxNumbers,
}) => {
  const { statNetworkVolume, setStatNetworkVolume } = useFilterWorkspace();

  const onFilterValueChange = (rangeFilter: RangeFilter) => {
    setStatNetworkVolume({ ...rangeFilter });
  };

  const numberOfActiveFilters = () => {
    return statNetworkVolume.from || statNetworkVolume.to ? 1 : 0;
  };

  return (
    <FppSearchFilterSection
      sectionId={"statNetworkVolume"}
      label={label}
      enabled={enabled}
      numSelected={numberOfActiveFilters()}
      leftIcon={stenaStatisticsBar}
      children={
        <RangeControl<RangeFilter>
          value={statNetworkVolume}
          valueFrom={statNetworkVolume.from}
          valueTo={statNetworkVolume.to}
          onValueChange={onFilterValueChange}
          labelFrom={labelFrom ?? "From"}
          labelTo={labelTo ?? "To"}
          maxNumbers={6}
          maxDecimals={maxDecimals}
        />
      }
    />
  );
};
